import type { Locale } from "./types";

export const locale = {
    default: {
        meta: {
            description: "Køb af biografbilletter online, filmnyheder, trailers samt brugerne og mediernes anmeldelser.",
            title: "Kino.dk"
        }
    },
    actions: {
        save: "Gem",
        cancel: "Afbryd",
        close: "Luk"
    },
    progress: {
        loading: "Loader..."
    },
    menu: {
        menu: "Menu",
        login: "Log ind"
    },
    ads: {
        sponsored: "Sponsoreret",
        contentAd: "Sponsoreret",
        adLabel: "Annonce",
        advertiser: "Annonceør",
        hideAd: "Skjul annonce"
    },
    filmomtale: {
        sg: { // not in use
            meta: {
                title: "strømme online - Streamingguide"
            }
        },
        availableOnCinema: "Filmen er tilgængelig i biografen. Klik her for at se forestillinger.",
        availableOnStreaming: "Filmen er tilgængelig på streaming. Klik her for at se, hvor den kan streames.",
        mediaLabel: "Anmeldelser fra medierne",
        starRatingLabel: "Anmelderne gav {{value}}",
        actorLabel: "Skuespillere",
        voiceActorLabel: "Danske stemmer",
        medvirkendeLabel: "Medvirkende",
        genreLabel: "Genre",
		originalTitle: "Originaltitel",
        besetningLabel: "Medvirkende",
        nasjonalitetLabel: "Nationalitet",
        produksjonsårLabel: "Produktionsår",
        distributørLabel: "Distributør",
        visesILabel: "Vises i",
        språkLabel: "Sprog",
        originalSpråk: "Originalsprog",
        actor: "Skuespiller",
        voiceActor: "Dansk stemme",
        orgVoiceActor: "Original stemme",
        director: "Instruktion",
        script: "Manus",
        versjon: "Version",
        seeGallery: "Se billedgalleri",
        ageRating: "Censur",
        ageRatingWithReason: "med vurdering",
        ageReasonExpand: "Læs mere",
        premiere: "Premiere",
        reRelease: "Repremiere",
        expectedPremeiere: "Antatt premiere",
        relatedNews: "Relaterede nyheder",
        latestNews: "Seneste nyheder"

    },
    forside: {
        articlesAndList: {
            follow: "Følg os"
        },
        topRatedMovieLists: {
            usersHeading: "Brugernes top 10",
            criticsHeading: "Anmeldernes top 10"
        }
    },
    navn: {
        noFilmography: "Ingen filmografi fundet"
    },
    trailere: {
        meta: {
            title: "Trailere",
            description: "Se de nyeste trailere til kommende film!",
        },
        heading: "Trailers",
        trailerButtonText: "Trailer"
    },
    articleSummary: {
        label: "Resumé af sagen",
        showMore: "Vis mere"
    },
    poster: {
        posterMissing: "Plakat mangler",
        posterFor: "Plakat til",
        customInfoLinkText: "Se program og filminfo"
    },
    providers: {
        incinema: "I biografen nu",
        presale: "Forsalg"
    },
    bilde: {
        imageMissing: "Billede mangler",
        imageGallery: "Billedgalleri"
    },
    watchlist: {
        signInToWatchlist: "Log ind for at tilføje til din huskeliste",
        addToWatchlist: "Føj filmen til huskelisten",
        filterAll: "Alle titler",
        filterInCinemas: "I biografen",
        filterComingToCinemas: "Kommer til biografen",
        filterStreaming: "På streaming"
    },
    favourites: {
        callToAction: "Markér denne film som favorit"
    },
    program: {
        meta: {
            title: "Biografbilletter og program",
            description: "Her finder du biografprogrammet og billetkøb til din biograf samt information om aldersgrænse, genre, trailer og fakta om filmen.",
            titleLocation: "Biografprogram for {{location}}",
            titleCinema: "Biografprogram for {{location}}, {{cinema}}",
            descriptionLocation: "Her er biografprogrammet og billetkøb for alle biografer i {{location}}! Her kan du filtrere efter sted, biograf, tidspunkt og genre.",
            descriptionCinema: "Her er biografprogrammet og billetkøb for alle biografer i {{location}}, {{cinema}}! Her kan du filtrere efter sted, biograf, tidspunkt og genre."
        },
        // keys for the program state in the url hash, e.g. #20.10.2026&biograf=Biograf+A&genre=Familiefilm
        hashKeys: {
            cinema: "biograf",
            genre: "genre"
        },
        // the cinema filter on film pages is only offered (and applied) when one of these is among the selected locations
        cinemaFilterLocations: ["København", "Storkøbenhavn"],
        pageTitle: "Biografprogram",
        pageTitleLocation: "Biografprogram for {{location}}",
        pageTitleCinema: "Biografprogram for {{cinema}} i {{location}}",
        pageSubtitleLocation: "Her finner du biografprogrammet og billetter for alle kinoer i {{location}}!",
        pageSubtitleCinema: "Her finner du biografprogrammet og billetter for {{cinema}} i {{location}}!",
        filterMessage: {
            template: "Dine filterindstillinger skjuler {{numFilteredMovies}} {{optionalShows}}",
            film: "film",
            shows: "forestillinger",
            reset: "Nulstil filtre"
        },
        noLocation: {
            action: "Klik for at vælge biografsted",
            prompt: "Søg på biograf eller by for at se spilletider."
        },
        loadError: {
            message: "Vi kunne ikke hente forestillingerne lige nu.",
            retry: "Prøv igen"
        },
        movie: {
            showMore: "Flere forestillinger",
            showLess: "Færre forestillinger",
            showAll: "Se alle forestillinger",
            readMore: "Læs mere"
        },
        noShows: {
            noMoreShowsDefault: "Denne film har ikke flere visninger.",
            expectedPremiere: "\"{{movieTitle}}\" har forventet biografpremiere {{premiere}}. Vil du have besked, når billetsalget starter, kan du tilføje filmen til huskelisten.",
            expectedPremiereMobile1: "Forventet biografpremiere {{premiere}}",
            expectedPremiereMobile2: "Klik her for at få besked om billetsalg.",
            premierePassed: "\"{{movieTitle}}\" havde biografpremiere {{premiere}}. Der er ikke planlagt nogen forestillinger af filmen lige nu. Prøv at vælge et andet biografsted — tryk på Skift herover",
            premierePassedMobile1: "Filmen havde biografpremiere {{premiere}}",
            premierePassedMobile2: "Der er ikke planlagt nogen forestillinger af filmen lige nu.",
            hasPremiere: "\"{{movieTitle}}\" har biografpremiere {{premiere}}. Vil du have besked, når billetsalget starter, kan du tilføje filmen til huskelisten.",
            hasPremiereMobile1: "Biografpremiere {{premiere}}",
            hasPremiereMobile2: "Klik her for at få besked om billetsalg.",
            nextShow: "Næste visning for denne film er",
            noMoreShowsForLocation: "Ingen forestillinger tilgængelige for det valgte biografsted",
            nextShowday: "Næste dag med film på programmet er",
            noShowsForSelectedCinemas: "Der er ingen forestillinger af filmen i de valgte biografer.",
            showAllCinemas: "Vis alle biografer"

        },
        changeLocation: "Skift",
        selectLocation: "Vælg sted",
        searchLocations: "Søg på et sted",
        locationHeading: "Vælg et eller flere steder",
        nearby: "Byer i nærheden",
        allCinemas: "Alle biografer",
        familyMovies: "Familiefilm",
        allDates: "Alle dager",
        moreCinemas: "Vælg biografer"
    },
    popularMoviesList: {
        label: "Populære film"
    },
    kommer: {
        meta: {
            title: "Kommende film",
            description: "Fuld oversigt over alle film, der får biografpremiere i Danmark."
        },
        heading: "Kommende film",
        subHeading: "",
        viewText: "Tekstliste",
        viewPoster: "Plakatliste",
        premThisWeekHeading: "Premiere i denne uge",
        posterIncoming: "Plakat kommer"
    },
    aktuelle: {
        meta: {
            title: "Aktuelle film",
            description: "Fuld oversigt over akutelle film."
        },
        heading: "Aktuelle film",
        subHeading: "",
        viewText: "Tekstliste",
        viewPoster: "Plakatliste",
        premThisWeekHeading: "Premiere i denne uge",
        posterIncoming: "Plakat kommer"
    },
    ticketButton: {
        buyTickets: "Køb billetter"
    },
    consent: {
        cookiesWait: "Venter på cookies",
        cookiesLabel: "For at se dette indhold skal {{cookiesNeeded}}cookies være slået til. Klik her for at ændre dine indstillinger.",
        cookieTypeMarketing: "marketing",
        cookieTypePreferences: "præference",
        cookieTypeStatistics: "statistik",
        cookieChangeButton: "Ændre/tilbagetræk cookiesamtykke"
    },
    kinotoppen: {
        meta: {
            title: "Biograftoppen",
            description: "Se hvilke film der topper biograflisterne i Danmark. Oversigt over weekendens mest sete og biograftoppen for i år."
        },
        heading: "Biograftoppen"
    },
    newsletter: {
        callToAction: "Hold dig opdateret",
        emailPlaceholder: "Indtast din e-mail",
        tosError: "Markedsføringssamtykke skal udfyldes",
        tosAcceptPreamble: "Ved tilmelding accepterer jeg samtidig Kino.dks",
        tosLink: "Markedsføringssamtykke"
    },
    user: {
        anonymous: "Anonym bruger",
        deleted: "Slettet bruger"
    },
    review: {
        alreadyReported: "Du har allerede rapporteret denne anmeldelse",
        report: "Rapportér anmeldelsen",
        reportHelperText: "Indrapporterede tekster vil blive vurderet af Kino.dks redaktion for at se, om de overtræder vores retningslinjer.",
        noReviews: "Indtil videre har ingen skrevet en anmeldelse af {{title}}",
        heading: "Anmeldelser fra publikum",
        callToAction: "Skriv anmeldelse",
        readMore: "Læs mere",
        seeMore: "Se flere",
        removeRatingError: "Kan ikke fjerne vurderingen, så længe der er en anmeldelse",
        validationError: "Vi tillader ikke links i teksterne. Fjern linket og gem igen.",
        validationErrorMaxLength: "Din anmeldelse er for lang! Maks {{MAX_REVIEW_LENGTH}} tegn",
        ratingRequired: "Du skal give en vurdering!",
        placeholder: "Skriv din anmeldelse...",
        seeReviews: "Se anmeldelser",
        removeReview: "Fjern anmeldelse",
        likeReview: "Giv denne anmeldelse et like!",
        reviewRestoredFromDraft: "En ugemt kladde blev genoprettet.",
        saveError: "Anmeldelsen kunne ikke gemmes. Prøv igen."
    },
    ratings: {
        headingCta: "Giv filmen din vurdering:",
        headingAvg: "Gennemsnit af vurderinger:",
        ratingCount: "Indtil videre har {{ratingCount}} givet en vurdering",
        ratingAverage: "Gennemsnit {{ratingAverage}} baseret på {{ratingCount}} vurderinger",
        yourRating: "Din vurdering:",
        noRating: "Indtil videre har ingen givet en vurdering.",
        ratingButtonLabel: "Giv filmen/serien {{RATING_VALUE}} {{RATING_VALUE_UNIT}}",
        ratingUnitSingular: "stjerne",
        ratingUnitPlural: "stjerner",
        callToAction: "Giv filmen din vurdering"
    },
    favorite: {
        callToAction: "Marker filmen som favorit"
    },
    footer: {
        someHeader: "Følg os",
        ourTerms: "Vores brugervilkår",
        cookieUsage: "Kino.dk bruger"
    },
    biograf: {
        transportHeading: "Transport og parkering",
        openingTimesHeading: "Åbningstider",
        contactHeading: "Kontakt og find vej"

    },
    filmnytt: {
        bottomSoMeHeader: "Følg os for de seneste nyheder, konkurrencer samt film- og serietips:",
        mostRead: "Mest læste nyheder",
        relatedNews: "Relaterede nyheder",
        byline: {
            redaksjonen: "Redaktionen",
            published: "Publiceret",
            lastUpdated: "Sidst opdateret",
            followUs: "Følg os"
        },
        section: {
            meta: {
                title: "Nyheder og artikler"
            }
        }
    },
    minside: {
        menu: {
            watchlist: "Min huskeliste",
            favorites: "Mine favoritter",
            ratings: "Mine vurderinger",
            reviews: "Mine anmeldelser",
            orders: "Mine bestillinger",
            settings: "Profil- og notifikationsindstillinger",
            logout: "Log ud"
        },
        myWatchlist: "Huskeliste",
        myWatchlistEmpty: "Du har ikke tilføjet noget til din huskeliste",
        myWatchlistFilterNoResults: "Dit filter gav ingen resultater",
        myRatings: "Mine vurderinger",
        myRatingsEmpty: "Du har ikke vurderet nogen film",
        myReviews: "Mine anmeldelser",
        myReviewsEmpty: "Du har ikke skrevet nogen anmeldelser",
        myFavourites: "Favoritter",
        myFavouritesEmpty: "Du har ikke markeret nogen film som favoritter",
        settings: {
            pageTitle: "Profil- og notifikationsindstillinger",
            alertLabel: "Notifikationsindstillinger for e-mail",
            alertDescription: "Jeg giver mit samtykke til at modtage en e-mail fra Kino.dk A/S, når en film på min watchlist har premiere i biografen. Du kan vælge nedenfor, hvilke situationer, der skal give en e-mail-notifikation. Jeg kan til enhver tid trække mit samtykke tilbage ved at fjerne afkrydsningen nedenfor. ",
            manageAccountButtonLabel: "Redigér brugeroplysninger",
            alerts: {
                cinemaPreferred: "Jeg vil gerne modtage en e-mail, når en film vises i min by / mit område*",
                cinemaNational: "Jeg vil gerne modtage en e-mail, når en film har national premiere, selvom den ikke vises i min by / mit område*",
                streamingAnyService: "Jeg vil gerne modtage en e-mail, første gang en titel dukker op på en streamingtjeneste",
                streamingSubscriptionService: "Jeg vil gerne modtage en e-mail, når en titel dukker op på en abonnementstjeneste",
                myCinemaExplanation: "\"Min by / mit område\" er det sted, du har valgt i biografprogrammet.",
                streamingSubscriptionServicesExplanation: "De abonnementstjenester, vi giver besked om, er Netflix, Disney+, HBO, Amazon Prime, AppleTV+, Paramount+, NRK, TV2 Play, Discovery+"
            },
        },
        orders: {
            pageTitle: "Mine bestillinger",
            noOrders: "Du har ingen købshistorik endnu",
            unknownFilm: "Ukendt film",
            bought: "Købt:",
            showDetails: "Vis detaljer",
            hideDetails: "Skjul detaljer",
            orderId: "Ordre",
            ticketCount: "Antal billetter:",
            ticketCountUnit: "billet(ter)",
            seeTickets: "Se billetter",
            receipt: "Kvittering",
            previousPage: "Forrige",
            nextPage: "Næste",
            showQrCodes: "Vis QR-koder",
            hideQrCodes: "Skjul QR-koder"
        },
        selfDeleter: {
            deleteButtonLabel: "Slet min bruger",
            confirmYes: "Ja, jeg er helt sikker",
            confirmNo: "Nej, jeg har skiftet mening!"
        },
        pictureUploader: {
            uploadInfo: "For det bedste resultat bør billedet være større end 100 x 100 pixels",
            errors: {
                tooLarge: "Filen er for stor! Billedet skal være mindre end 20 MB.",
                fileType: "Billedtypen understøttes ikke! Billedet skal være af typen jpeg, png, webp eller gif",
                generic: "Der opstod en fejl under upload af billedet.",
                tooSmall: "Billedet er for lille! Billedet skal være mindst 100 x 100 pixels"
            },
            callToAction: "Upload profilbillede",
            uploadNewButtonLabel: "Upload profilbillede",
        }
    },
    kinoklubb: {
        posterbanner: "Halv pris med Biografklub Danmark",
        showsbanner: "* Halv pris på [https://www.biografklubdanmark.dk/|Biografklub Danmark-forestillinger]"
    },
    error: {
        notfound: {
            title: "Der skete desværre en fejl 404",
            subheading: "You shall not pass!",
            body: "Vi kunne ikke finde den efterspurgte side. Det kan skyldes, at siden ikke findes, at siden er flyttet, eller at linket er skrevet forkert.",
            listHeading: "Vi anbefaler, at besøger eller gør følgende:",
            listItems: [
                "Kino.dk's [/|forside]",
                "[/program|Biografprogrammet]",
                "[/nyheder|Nyhedsoversigten]",
                "Bruger søgefeltet i menuen"
            ],
            postheading: "Mangler du stadig svar, eller har du forslag til noget, som burde være anderledes? Så send gerne en e-mail til os på [mailto:kontakt@kino.dk|kontakt@kino.dk]."
        }
    },
    search: {
        action: "Søg",
        prompt: "Søg på filmens titel her",
        results: "Søgeresultat",
        noresults: "Ingen resultater",
        placeholder: "Søg på filmens titel her",
        seeMore: "Se flere film",
        locationResultHeading: "Resultater for biografsteder"
    },
    biografi: {
        actor: "Medvirker",
        director: "Instruktion",
        voice: "Stemmer"
    },
    componentFilmwebNews: {
        header: "Nyheder"
    },
    dateSelector: {
        previousMonth: "Forrige måned",
        nextMonth: "Næste måned"
    }

} as const satisfies Locale;